<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>单词训练
    </div>
    <div class="xiaoqu moerduo">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="grid-content bg-purple scrollbarStyle treeStyle" style="height: 85vh; overflow: auto">
            <div class="xiaoqu_1">教材目录</div>
            <el-tree ref="tree" :data="data2" :highlight-current="true" @node-click="handleNodeClick" :props="props" node-key="id"
              :default-checked-keys="[bookid_1]" @check-change="dianxuan">
              <span class="span-ellipsis" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple scrollbarStyle mo_shiyong trialscope0" style="height: 85vh; overflow: auto">
            <el-dialog title="新建章节" :visible.sync="addChapterandsections" width="600px">
              <div class="form_1 form_1_1">
                <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                  <el-form-item label="章节名称" prop="name">
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" alt />
                    </i>
                    <el-input v-model="forms.name" placeholder="请输入文件夹名称"></el-input>
                  </el-form-item>
                  <el-form-item label="章节顺序" prop="seqnum">
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" alt />
                    </i>
                    <el-input v-model="forms.seqnum" placeholder="请输入章节顺序"></el-input>
                  </el-form-item>
                  <el-form-item label="章节封面" class="zhangjie_btn">
                    <el-upload action="#" :show-file-list="false" :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                      class="lbt_item">
                      <el-button type="primary" class="banji_ht">上传图片</el-button>
                    </el-upload>
                    <div class="banji_tu">
                      <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="tempImg" :src="tempImg" class="avatar" />
                      </el-upload>
                    </div>
                    <div class="jianyi">
                      <span>
                        ( 建议：JPG或PNG图片，
                        推荐：180*230，如不上传图片，则使用系统默认图片)
                      </span>
                    </div>
                  </el-form-item>
                  <el-form-item class="queding">
                    <el-button type="primary" @click="addChapterandsection">
                      确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>

            <el-dialog title="试用范围" :visible.sync="addStudents">
              <div class="form_1 form_1_1">
                <el-form ref="Trialscope" :model="Trialscopes" :rules="FormRules" label-width="5.20833vw">
                  <el-form-item label="试用范围" class="fanwei0">
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" alt />
                    </i>
                    <el-input v-model="form.name" disabled></el-input>
                  </el-form-item>
                  <el-form-item label>
                    <div class="fanwei1 scrollbarStyle">
                      <div v-for="(item, index) in shiyongzhangjie" :key="index" :class="item.probation === 1 ? 'fanwei1_0' : ''"
                        @click="fanweis0(item)">
                        <span v-if="item.level === 0" class="fanwei1_1">
                          {{ item.title }}
                        </span>
                        <span v-if="item.level === 1">{{ item.title }}</span>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label>
                    <div class="fanwei2">
                      （注：在选择可试用范围时，选择的为章节时，选中为它之前的所有内容；为内容时，所选中的为它和它之前的所有内容）
                    </div>
                  </el-form-item>
                  <el-form-item class="queding">
                    <el-button type="primary" @click="qd_shiyong">
                      确定
                    </el-button>
                    <el-button @click="quxiao0">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>

            <div class="xiaoqu_1 mo_erfuo">单词训练</div>
            <div v-if="yincang">
              <el-button type="primary" class="buttons xj_wjj" @click="addChapterandsection_xinjian">
                <span>+</span>
                新建章节
              </el-button>
              <el-button v-if="additionalinfo" class="daoru_btn daoru_btn2" @click="updateChapter2">
                <img src="@/assets/img/textbook-manage/selfbook/suo.png" />
                <span> 试用范围</span>
              </el-button>
              <div class="sousuo sousuo_wjj">
                <span>素材名称：</span>
                <el-input v-model="orgnames" @keyup.13.native="selectcsPage" placeholder="请输入素材关键字进行查找"></el-input>
                <el-button type="primary" class="buttons sousuo_wjj1" @click="selectcsPage()">查 询</el-button>
              </div>
              <div class="zsbg_1 jiaocai_1">
                <div class="jiaocai" v-for="(item, index) in jiaoyu" :key="index" @click="daoru_a(item.id)">
                  <div class="jiaocai_tu">
                    <img :src="item.picurl" style="border-radius: 0.52083vw" alt="" />
                  </div>
                  <div class="jiaocai_zi">{{ item.title }}</div>
                </div>

                <div class="function_zong">
                  共<span> {{ total }} </span>本教材，当前页面显示
                  <span>
                    {{ jczongshu0 }}
                  </span>
                  本
                </div>
                <el-pagination class="function-page" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'testing',
  data() {
    return {
      props: {
        children: 'children',
        label: 'label',
      },
      FormRules: {},
      orgnames: '',
      tempImg: '',
      m_id: '',
      data2: [],
      jiaoyu: [],
      bookid_1: '',
      page: 1,
      pageSize: 21,
      currentPage: 1,
      total: 0,
      forms: {
        name: '',
        seqnum: 0,
      },
      addChapterandsections: false,
      form: {
        name: '',
        description: '',
        level: '',
      },
      Trialscopes: {},
      addStudents: false,
      shiyongzhangjie: [],
      additionalinfo: false,
      jczongshu0: '',
      yincang: true,
    };
  },
  created() {
    this.miniInfoSetting();
  },
  destroyed() {
    localStorage.removeItem('testingear0');
  },
  methods: {
    qd_shiyong() {
      let arr = [];
      for (var i = 0; i < this.shiyongzhangjie.length; i++) {
        if (this.shiyongzhangjie[i].probation === 1) {
          // console.log(i)
          arr.push(this.shiyongzhangjie[i]);
        }
      }
      // console.log(arr)
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/updateWordPracticeProbation',
        data: arr,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addStudents = false;
          return this.$message.success(result.data.message);
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('确定试用范围失败：' + err);
        });
    },
    fanweis0(item) {
      // console.log(item)
      for (var a = 0; a < this.shiyongzhangjie.length; a++) {
        this.shiyongzhangjie[a].probation = 0;
      }
      if (item.level === 1) {
        for (var l = 0; l < this.shiyongzhangjie.length; l++) {
          if (this.shiyongzhangjie[l].level === 1 && item.id === this.shiyongzhangjie[l].id) {
            for (var b = 0; b < l + 1; b++) {
              // console.log(this.shiyongzhangjie[b])
              this.shiyongzhangjie[b].probation = 1;
            }
          }
        }
      } else {
        for (var i = 0; i < this.shiyongzhangjie.length; i++) {
          if (this.shiyongzhangjie[i].level === 0 && item.id === this.shiyongzhangjie[i].id) {
            for (var j = 0; j < i; j++) {
              // console.log(this.shiyongzhangjie[j])
              this.shiyongzhangjie[j].probation = 1;
            }
          }
        }
      }
    },
    // 查询试用范围
    updateChapter2() {
      this.addStudents = true;
      let bookid = this.bookid_1;
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/wordpractice/getCatalogueByBook/' + bookid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.shiyongzhangjie = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询试用范围失败：' + err);
        });
    },
    quxiao0() {
      this.addStudents = false;
    },

    dianxuan() {
      this.$refs.tree.setCheckedKeys([]);
    },
    // 导入音频
    daoru_a(e) {
      for (var i = 0; i < this.jiaoyu.length; i++) {
        if (this.jiaoyu[i].id === e) {
          var testing = this.jiaoyu[i];
        }
      }
      // console.log(e)
      this.$store.commit('testing', testing);
      this.$router.push({
        path: '/testingear',
      });
    },

    // 上传图片
    handleAvatarSuccess(data) {
      // console.log(data.file)
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('orgid', orgid);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniInfo/uploadimage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            this.tempImg = url;
          } else {
            this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },

    // 上传图片大小
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      return isJPG | isPNG && isLt2M;
    },

    // 新建文件夹
    addChapterandsection_xinjian() {
      if (this.bookid_1 === null || this.bookid_1 === '') {
        return this.$message.error('请先选择所属教材');
      }
      this.addChapterandsections = true;
    },
    quxiao() {
      this.addChapterandsections = false;
    },
    addChapterandsection() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/chapterandsection/addChapterandsection',
        method: 'POST',
        data: {
          orgid: orgid,
          bookid: this.bookid_1,
          title: this.forms.name,
          seqnum: this.forms.seqnum,
          picurl: this.tempImg,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addChapterandsections = false;
          this.selectcsPage();
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('新建文件夹失败：' + err);
        });
    },

    handleNodeClick(data) {
      // console.log(data)
      this.yincang = true;
      if (data.status === 1) {
        this.yincang = false;
        return this.$message.warning('该教材已上架，不可修改！');
      }
      if (data.type === 0) {
        this.bookid_1 = data.id;
        this.form.name = data.label;
        this.selectcsPage();
      } else {
        this.bookid_1 = '';
      }
    },

    // 查询系统设置信息
    miniInfoSetting() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/getGroupTree/' + orgid,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.data2 = result.data.data;
          if (this.$store.state.testingear0) {
            this.bookid_1 = window.localStorage.getItem('testingear0');
            console.log(this.bookid_1);
          } else {
            this.bookid_1 = result.data.data[0].children[0].children[0].id;
          }
          this.selectcsPage();
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询词汇训练失败：' + err);
        });
    },

    // 查询文件夹
    selectcsPage() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/chapterandsection/selectcsPage',
        method: 'POST',
        data: {
          orgid: orgid,
          bookid: this.bookid_1,
          title: this.orgnames,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          if (result.data.additionalinfo === '1') {
            this.additionalinfo = true;
          } else {
            this.additionalinfo = false;
          }
          this.form.name = result.data.additionalinfo2;
          var data = result.data.data;
          if (data.length === 0) {
            this.jiaoyu = data;
            return this.$message.success('您查询的数据为空！');
          }
          this.jiaoyu = data;
          this.jczongshu0 = data.length;
          if (data === undefined || data === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询文件夹失败：' + err);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      // this.$options.methods.chaxun()
      this.selectcsPage();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.selectcsPage();
    },
  },
};
</script>

<style lang="less">
</style>
